<template>
	<div class="table">
		<div style="padding: 10px 0 0 10px; display: flex; gap: 10px; align-items: center;">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" backgroundColor="#FFF" title="导入" fontSize="14px" @getFile="Import" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a class="Dowload" v-if="qx.add" style="margin-left: 10px; font-size: 14px; color: #333; text-decoration: underline; cursor: pointer;" @click="DownloadTemplet">导入模板下载</a>
		</div>
		<div class="tables">
			<Commontable :loadingTable="false" :tableData="tableData" :headerData="headerData" :colnum="7" height="100%">
			</Commontable>
		</div>
		<div style="height: 10px;"></div>
		<div style="text-align: right;padding: 20px;">
			<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
				:pageNo="pageNo" :pageSize="pageSize" :total="total" type="all"></Pagination>
		</div>
	</div>
</template>

<script>
	import Commontable from '@/components/common-table.vue'
	import Pagination from '@/components/pagination.vue'
	import Commonbtn from '@/components/common-btn.vue'
	import CommonbtnUpLoad from '@/components/common-upload.vue'

	export default {
		components: {
			Commontable,
			Pagination,
			Commonbtn,
			CommonbtnUpLoad
		},
		props: {
			tableData: {
				type: Array,
				default: () => {
					return []
				}
			},
			total: {
				type: Number,
				default: 1
			},
			isLoading: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				qus: [],
				pageNo: 1,
				pageSize: 20,
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: false,
					daoc: false,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				},
				headerData: [
					{
						prop: "InvClassName",
						label: "产品线",
						columnwidth: "100"
					},
					{
						prop: "ProvinceName",
						label: "省份",
						columnwidth: "100"
					},
					{
						prop: "Warehouse",
						label: "寄售点",
						columnwidth: "200"
					},
					{
						prop: "InvAddCode",
						label: "产品型号",
						columnwidth: ""
					},
					{
						prop: "LEVEL2",
						label: "LEVEL2",
						columnwidth: "100"
					},
					{
						prop: "LEVEL3",
						label: "LEVEL3",
						columnwidth: "100"
					},
					{
						prop: "LEVEL4",
						label: "LEVEL4",
						columnwidth: "100"
					},
					{
						prop: "InvName",
						label: "产品名称",
						columnwidth: ""
					},
					{
						prop: "Quantity",
						label: "数量",
						columnwidth: "100"
					},
					{
						prop: "CreateTime",
						label: "上报日期",
						columnwidth: "150"
					}
				]
			}
		},
		mounted() {
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let NodeID = this.$route.query.NodeID
				data.Menus.map((item, index) => {
					if (item.NodeID == 18) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 1109) {
								this.qus = items.Nodes
							}
						})
					}
				})
				//console.log(this.qus, 'qus');
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'revoke') {
							this.qx.revoke = true
						}
					})
				}
			},
			Export() {
				this.$emit('Export')
			},
			DownloadTemplet() {
				this.$emit('DownloadTemplet')
			},
			Import(file) {
				this.$emit('Import', file)
			},
			handleCurrentChange(pageindex) {
				this.pageNo = pageindex
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.$emit('handleSizeChange', paegSzie)
			},
		}
	}
</script>

<style lang="less" scoped>
	.table {
		width: 100%;
		height: 100%;
	}

	.tables {
		padding: 10px 10px 10px 0px;
	}
	.Dowload:hover {
		color: #E71D43 !important;
	}
</style>
